import { FleetUUIDs } from '../enums/fleets';
import { Fleet } from '../interfaces';

export const isLondon = (fleet: Fleet) =>
  // FIXME use a proper feature flag here - this is just temporary so we can test in a non-eu tenant ENV
  fleet.uuid === FleetUUIDs.TFL || fleet.uuid === FleetUUIDs.TFLStaging;

// FIXME use a proper feature flag here - temporary, used only to hide the Reports page
// from WMATA's customer-scope users. Takes an optional fleet so it is safe before one loads.
export const isWMATA = (fleet?: Fleet) => fleet?.uuid === FleetUUIDs.WMATA;
